import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const limaCharlie = defineConnector({
  identifier: "limaCharlie",
  name: "LimaCharlie",
  tagLine: "Cloud-native security infrastructure",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.limacharlie\\.io/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://jwt.limacharlie.io",
        formBody: {
          oid: app.config.oid,
          secret: app.secret.apiKey,
        },
      },
      extract: { from: "jsonPath", paths: ["jwt"] },
      apply: { kind: "header", scheme: "Bearer" },
      cache: { ttlSeconds: 3300 },
    }),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [LimaCharlie](https://app.limacharlie.io) web console, go to **Access Management > REST API** to create an API key.",
        },
      ],
    },
    {
      title: "Enter your organization ID and API key",
      items: [
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "oid" },
          helperText: "Your LimaCharlie organization ID.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ oid }) => `https://api.limacharlie.io/v1/orgs/${oid}`,
  },
});
